/**
 * Векторные штриховки материалов стен.
 *
 * Геометрия каждой штриховки строится в мировой системе координат и обрезается
 * контуром стены, поэтому рисунок продолжается через стыки соседних стен.
 */
import { getMaterial, WallMaterial } from "@/shared/catalog";
import type { Wall } from "@/shared/plan";
import type { WallOutline } from "@/widgets/plan";
import { BlockHatch } from "./BlockHatch";
import { BrickHatch } from "./BrickHatch";
import { ConcreteHatch } from "./ConcreteHatch";
import { DrywallHatch } from "./DrywallHatch";
import { OtherHatch } from "./OtherHatch";
import { WoodHatch } from "./WoodHatch";

const outlinePoints = (outline: WallOutline) =>
	outline.map((point) => `${point.x},${point.y}`).join(" ");

interface Props {
	wall: Wall;
	outline: WallOutline;
}

export const WallMaterialHatch = ({ wall, outline }: Props) => {
	const clipId = `wall-hatch-${wall.id}`;
	const material = getMaterial(wall.material).material;
	const hatch =
		material === WallMaterial.Block ? (
			<BlockHatch outline={outline} />
		) : material === WallMaterial.Brick ? (
			<BrickHatch outline={outline} />
		) : material === WallMaterial.Concrete ? (
			<ConcreteHatch outline={outline} />
		) : material === WallMaterial.Drywall ? (
			<DrywallHatch outline={outline} />
		) : material === WallMaterial.Wood ? (
			<WoodHatch outline={outline} />
		) : material === WallMaterial.Other ? (
			<OtherHatch outline={outline} />
		) : null;

	if (!hatch) return null;
	return (
		<g style={{ pointerEvents: "none" }}>
			<defs>
				<clipPath id={clipId}>
					<polygon points={outlinePoints(outline)} />
				</clipPath>
			</defs>
			<g clipPath={`url(#${clipId})`}>{hatch}</g>
		</g>
	);
};
